export default __webpack_public_path__ + "static/media/avatar.2decb6e0.svg";